module.exports = __webpack_public_path__ + "static/media/active-committees.61b60fa9.png";